<template>
  <b-modal
    id="remove-shift"
    size="md"
    centered
    ok-title="Usuń zmianę"
    cancel-title="Anuluj"
    ok-variant="danger"
    @ok="removeShift"
    :title="`Usuwasz zmianę ${shiftToRemove.val.fullName} - ${shiftToRemove.val.shift} / ${shiftToRemove.val.dayName}`"
  >
  <b-alert variant="danger" show>
    Pamiętaj aby zaktualizować grafik po usunięciu zmiany.
  </b-alert>
      <b-form-group label="Wybierz powód" >
        <b-form-radio
          v-model="reason"
          :name="item"
          :value="item"
          v-for="item in reasons"
          >{{item}}</b-form-radio
        >

      </b-form-group>

    <b-form-group v-if="reason === 'Inny powód'" label="Wprowadź inny powód...">
      <b-input v-model="otherReason"></b-input>
    </b-form-group>
  </b-modal>
</template>



<script>
export default {
  props: ["shiftToRemove"],
  data() {
    return {
      reason: null,
      otherReason: null,
      reasons: [
        "Choroba - ma L4",
        "Choroba - nie ma L4",
        "Źle wybrał zmianę",
        "Inne zobowiązania",
        "Inny powód",
      ],
    };
  },
  methods: {
    removeShift() {
      this.$emit("clickedToRemove", {
        shift: this.shiftToRemove,
        reason: this.reason === "Inny powód" ? this.otherReason : this.reason,
      });
    },
  },
};
</script>

<style scoped>
</style>
